import { PreQualificationStep, setPreQualificationStep } from 'actions';
import { setApplication } from 'actions/application';
import { setCoBorrower } from 'actions/coBorrower';
import { setDashboardStep } from 'actions/stages';
import { ApplicationStatus } from 'enums/ApplicationStatus';
import { DashboardStep } from 'enums/DashboardStep';
import { LoanInformationVariables } from 'enums/LoanInformationVariables';
import { AppRoutes } from 'routes/routes.enums';

import { ApplicationDto } from '../api/ApplicationApi';

export const checkBorrower = ({
  borrowerApplication,
  hasCobborowerApplication,
  dispatch,
  navigator,
  nextStep,
  isForceRedirectToDashboard,
}: {
  borrowerApplication?: ApplicationDto;
  hasCobborowerApplication: boolean;
  dispatch: any;
  navigator: (route: AppRoutes) => void;
  nextStep: PreQualificationStep;
  isForceRedirectToDashboard?: boolean;
}) => {
  if (isForceRedirectToDashboard && !borrowerApplication && !hasCobborowerApplication) {
    dispatch(setDashboardStep(DashboardStep.NoActiveApplication));
    navigator(AppRoutes.Dashboard);
  } else if (borrowerApplication) {
    const variables = borrowerApplication.variables;

    dispatch(
      setApplication({
        applicationId: borrowerApplication.id,
        [LoanInformationVariables.AssignedConsultant]: {
          name: variables.consultant_sender_name || '',
          position: variables.consultant_sender_position || '',
          email: variables.consultant_sender_email || '',
          phone: variables.consultant_sender_phone || '',
        },
        applicationStatus: borrowerApplication?.status?.name as ApplicationStatus,
      }),
    );
    dispatch(
      setCoBorrower({
        firstName: variables.coborrower_first_name as string,
        lastName: variables.coborrower_last_name as string,
      }),
    );

    if (isForceRedirectToDashboard) {
      navigator(AppRoutes.Dashboard);
    } else {
      dispatch(setPreQualificationStep(PreQualificationStep.AlreadyHaveActiveApplication));
      navigator(AppRoutes.Prequalification);
    }
  } else if (hasCobborowerApplication) {
    dispatch(setPreQualificationStep(PreQualificationStep.BorrowerAsCoBorrowerAlreadyHaveActiveApplication));
    navigator(AppRoutes.Prequalification);
  } else {
    dispatch(setPreQualificationStep(nextStep));
    navigator(AppRoutes.Prequalification);
  }
};
